module.exports = __webpack_public_path__ + "static/hackathon-6-74b9c49b4c22735029bd70373d1c1523.jpg";